import type { SubscriptionStore } from "@/Modules/Subscription/Store";

import SubscriptionApiConnector from "@/Services/TherapyApi/Subscriptions";

import SubscriptionTransformer, {
  type SubscriptionTransformerType,
} from "@/Modules/Transformers/Subscription";

import { danger } from "@/Utils/Debug";

class GetSubscriptionActionHandler {
  constructor(
    private readonly subscriptionStore: SubscriptionStore,
    private readonly subscriptionApiConnector: SubscriptionApiConnector = new SubscriptionApiConnector(),
    private readonly subscriptionTransformer: SubscriptionTransformerType = SubscriptionTransformer
  ) {}

  public async handle(userId: string) {
    this.subscriptionStore.isLoading = true;

    try {
      const subscriptionResponse = await this.subscriptionApiConnector.getSubscription(userId);

      this.subscriptionStore.subscription = this.subscriptionTransformer.toDomain(subscriptionResponse);
    } catch (error: unknown) {
      danger(error);
      this.subscriptionStore.subscription = null;
    } finally {
      this.subscriptionStore.isLoading = false;
    }
  }
}

export default GetSubscriptionActionHandler;
